import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

interface AddressLabels {
  street: string;
  complex: string;
  suburb: string;
  city: string;
  businessName: string;
  postalCode: string;
  province: string;
  country: string;
}

interface AddressLabelCountries {
  default: AddressLabels;
  'ZA/en-ZA': AddressLabels;
  'GB/en-GB': AddressLabels;
  'US/en-ZA': AddressLabels;
}

export const ADDRESS_LABEL_COUNTRIES: AddressLabelCountries = {
  default: {
    street: 'Street',
    complex: 'Complex',
    suburb: 'Suburb',
    city: 'City',
    businessName: 'Business Name',
    postalCode: 'Postal Code',
    province: 'Province',
    country: 'Country',
  },
  'ZA/en-ZA': {
    street: 'Street',
    complex: 'Complex',
    suburb: 'Suburb',
    city: 'City',
    businessName: 'Business Name',
    postalCode: 'Postal Code',
    province: 'Province',
    country: 'Country',
  },
  'GB/en-GB': {
    street: 'Street',
    complex: 'Complex',
    suburb: 'Suburb',
    city: 'City',
    businessName: 'Business Name',
    postalCode: 'Postcode',
    province: 'County',
    country: 'Country',
  },
  'US/en-ZA': {
    street: 'Street',
    complex: 'Complex',
    suburb: 'Suburb',
    city: 'City',
    businessName: 'Business Name',
    postalCode: 'ZIP code',
    province: 'State',
    country: 'Country',
  },
};

export function getLabelValue(
  label: keyof AddressLabels,
  country: keyof AddressLabelCountries = 'default',
  suffix?: string,
): string {
  const labels = ADDRESS_LABEL_COUNTRIES[country] || ADDRESS_LABEL_COUNTRIES.default;
  return `${labels[label]}${suffix}`;
}

@Pipe({
  name: 'addressFormLabel',
})
export class AddressFormLabelPipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID)
    private readonly locale: string,
  ) {}

  transform(value: keyof AddressLabels, ...args: [countryCode?: string, suffix?: string]): string {
    const [countryCode, suffix] = args;
    const newSuffix = suffix ? suffix : '';
    try {
      if (!ADDRESS_LABEL_COUNTRIES.default.hasOwnProperty(value)) {
        return this.getDefaultValue(value, newSuffix);
      }

      const [language, countryFromLocale] = this.locale.split('-');
      const effectiveCountryCode = countryCode
        ? `${countryCode}/${this.locale}`
        : `${countryFromLocale}/${this.locale}`;

      // Get the label value
      return getLabelValue(value, effectiveCountryCode as keyof AddressLabelCountries, newSuffix);
    } catch (e) {
      return this.getDefaultValue(value, newSuffix);
    }
  }

  getDefaultValue(value: string, suffix: string): string {
    return `${value}${suffix}`;
  }
}
